/**
 * API 基础 URL
 * 来自环境变量 VITE_API_BASE
 * 在 .env.development 和 .env.production 中配置
 */
export const API_BASE = import.meta.env.VITE_API_BASE || ""
